import {management} from '../../../index.js' //api
import {Et0Repository} from '../../infra/knex/repositories/et0'

import {GetStationOptionsUseCase} from './getStationsOptions'

export const getStationOptionsUseCase=new GetStationOptionsUseCase(new Et0Repository(management))
